module.exports = __webpack_public_path__ + "static/agnes-936e5551f26ccc88c4b0415fad1e7c8c.png";